import { Platform } from "react-native";
import uuid from "react-native-uuid";
import { setAppLinkClickId } from "@actions/deepLink.actions";
import { androidAppStore } from "@config";
import { APPLINK_PREFIX } from "@navigation";
import { store } from "@store";
import { generateLinkParams } from "@utils/URL";
import getUserData from "./applinks/getUserData";

const getAppLinkParams = async ({
  event_name = "",
  extraAttributionData = {},
}) => {
  let userData = await getUserData();
  const { referer: refererObject } = userData || {};
  userData = { ...userData, referer: undefined };
  const deepLink = store.getState()?.deepLink || {};
  const referer = deepLink?.referer || {};
  const appLinkHashResult = deepLink?.hashResult || {};

  const last_attributed_touch_data = {
    ...generateLinkParams(decodeURIComponent(userData?.play_referrer)).getAll(),
    ...generateLinkParams(decodeURIComponent(appLinkHashResult?.href)).getAll(),
    ...extraAttributionData,
    app_store: Platform.OS === "ios" ? "appstore" : androidAppStore,
  };

  let { link_click_id } = last_attributed_touch_data || {};

  if (!link_click_id) {
    link_click_id = deepLink?.appLinkClickId;
    if (!link_click_id) {
      link_click_id = uuid.v4();
      store.dispatch(setAppLinkClickId(link_click_id));
    }
  }

  const {
    utm_source,
    utm_medium,
    utm_campaign,
    utm_content,
    dollar_3p = "",
    hash: lastAttributedHash,
  } = last_attributed_touch_data || {};

  const utm =
    appLinkHashResult?.utm || (referer && referer.hashResult?.utm) || {};

  utm.utm_medium = utm.utm_medium || utm_medium;
  utm.utm_source = utm.utm_source || utm_source;
  utm.utm_content = utm.utm_content || utm_content;
  utm.utm_campaign = utm.utm_campaign || utm_campaign;

  const vendor =
    appLinkHashResult?.vendor || referer?.hashResult?.vendor || dollar_3p;

  const hash =
    appLinkHashResult?.hash || referer?.hashResult?.hash || lastAttributedHash;

  const url =
    appLinkHashResult?.href || appLinkHashResult?.prefix
      ? appLinkHashResult?.prefix + hash
      : hash
        ? APPLINK_PREFIX + hash
        : "";

  return {
    link_click_id,
    user_id: store.getState()?.user?.user?.user_id,
    event_name,
    url,
    click_timestamp: String(+new Date()),
    utm,
    vendor,
    last_attributed_touch_data,
    user_data: userData,
    hash,
    idfa: userData?.idfa,
    referer: refererObject,
  };
};

const OPEN_EVENTS = {
  install: "INSTALL",
  reinstall: "REINSTALL",
};

const AppLinkEvents = {
  install: "INSTALL",
  reinstall: "REINSTALL",

  charged: "PURCHASED",
  order_cancelled: "ORDER_CANCELLED",

  // Unused
  // click: "CLICK",
  // verified: "NUMBER_VERIFIED",
};

export { getAppLinkParams, OPEN_EVENTS, AppLinkEvents };
